export const CA_APP_NAME = 'content_entry_frontend';
export const CA_QUESTION_PRESET = 'question';
export const CA_CONFIDENCE_PRESET = 'confidence';

export const UPLOAD_FINAL_ASSETS_BY_VENDOR_PRESET = 'uploadFinalAssetsByVendor';
export const UPLOAD_SOURCE_ASSETS_BY_VENDOR_PRESET = 'uploadSourceAssetsByVendor';
